import chevronDownIcon from "./chevron_down.svg";
import cheveronDownSmallIcon from "./cheveron_down_small.svg";
import datePickerIcon from "./date_picker.svg";
import checkBoxCheckedIcon from "./check_box_checked.svg";
import deleteIcon from "./delete_icon.svg";
import deleteIconDark from "./delete_icon_dark.svg";
import fileUploadIcon from "./file_upload.svg";
import contractImportIcon from "./contract_import.svg";
import closeIcon from "./close_icon.svg";
import contractAddIcon from "./contract_add.svg";
import checkIcon from "./check_icon.svg";
import closeRedIcon from "./close_icon_red.svg";
import expandMore from "./expand_more.svg";
import editIconOrange from "./edit_orange.svg";
import editPencilIcon from "./edit.svg";
import visibilityIcon from "./visibility.svg";
import downloadIcon from "./download.svg";
import searchIcon from "./search_icon.svg";
import addComponent from "./add_component.svg";
import ledger_icon from "./ledger_icon.svg";
import upIndicator from "./up_indicator.svg";
import downIndicator from "./down_indicator.svg";
import rectangle from "./rectangle.svg";
import checkCircle from "./check_circle.svg";
import assignment_add from "./assignment_add.svg";
import upload from "./upload.svg";
import history from "./history.svg";
import check_small from "./check_small.svg";
import close from "./close.svg";
import addIcon from "./add.svg";
import wallet from "./wallet.svg";
import add_circle1 from "./add_circle1.svg";
import plusIcon from "./plusIcon.svg";
import minus from "./minus.svg";
import saveSolid from "./save_solid.svg";
import refundIcon from "./cashback-inr-icon.svg";
import forclosureIcon from "./foreclosure.svg";

export {
  chevronDownIcon,
  check_small,
  cheveronDownSmallIcon,
  datePickerIcon,
  checkBoxCheckedIcon,
  deleteIcon,
  deleteIconDark,
  fileUploadIcon,
  contractImportIcon,
  closeIcon,
  contractAddIcon,
  checkIcon,
  closeRedIcon,
  expandMore,
  editIconOrange,
  editPencilIcon,
  visibilityIcon,
  downloadIcon,
  searchIcon,
  addComponent,
  ledger_icon,
  upIndicator,
  downIndicator,
  rectangle,
  checkCircle,
  assignment_add,
  upload,
  history,
  close,
  addIcon,
  wallet,
  add_circle1,
  plusIcon,
  minus,
  saveSolid,
  refundIcon,
  forclosureIcon,
};
